import React, { useState } from 'react'; 
import { Typography, Button } from 'antd';
import { DeleteOutlined, CloudUploadOutlined} from '@ant-design/icons';
import UploadButton from '../assetUpload/uploadButton/UploadButton';  
import './styles.less';

const FileUpload = ( { value = [], onSelectFileCallback, accept } ) => {
    const [ fileName, setFileName ] = useState( value && value.length > 0 ? value[ 0 ].name : ''  );
    
    const handleFileSelect = ( file ) => {
        if ( file ) { 
            setFileName( file.name );
            onSelectFileCallback( file );
        } else  {
            setFileName( '' );
            onSelectFileCallback( file );
        }
    };

    const handleRemoveFile = () => {
        setFileName( '' );
        onSelectFileCallback( false );
    };

    return ( 
        <div className="file-upload">
            
            { fileName &&
                <div className="file-container">
                    <div  >
                        <Typography.Paragraph ellipsis={ { rows: 2 } }>
                            <CloudUploadOutlined /> 
                            &nbsp;
                            { fileName }
                        </Typography.Paragraph>
                         
                    </div>

                    <div className="file-box file-box2">
                        <Button
                            icon={ <DeleteOutlined /> }
                            size={ 'small' }
                            danger 
                            onClick={ () => {
                                handleRemoveFile(); 
                            } }
                        >
                            Delete
                        </Button>
                    </div>
                </div>
            }
             
            <div style={ { display: fileName ? 'none' : 'inline-block ' } } >
                <UploadButton 
                    accept={ accept }
                    onAdd={ handleFileSelect }
                >
                    Drag and drop or click to choose file to upload
                </UploadButton>
            </div>
        </div>
    );
};

export default FileUpload;
